"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVoteFieldValue = exports.getVoteFieldEmptyValue = void 0;
const getVoteFieldEmptyValue = () => ({
    total_votes: 0,
    votes: [],
});
exports.getVoteFieldEmptyValue = getVoteFieldEmptyValue;
const generateVoteFieldValue = (value) => {
    return { ...(0, exports.getVoteFieldEmptyValue)(), ...value };
};
exports.generateVoteFieldValue = generateVoteFieldValue;
